import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ClosableComponent} from '../../../models/closable.component';

@Component({
    selector: 'app-show-voucher',
    templateUrl: './show-voucher.component.html',
    styleUrls: ['./show-voucher.component.scss']
})
export class ShowVoucherComponent extends ClosableComponent implements OnInit {
    @Input() public voucher: any;
    @Input() restaurants: any[] = [];
    @Input() notFromVoucherList:boolean = false;

    constructor(public bsModalRef: BsModalRef) {
        super(bsModalRef)
    }

    ngOnInit() {
    }

}
